export default {
  'settings.name': 'Cài đặt hệ thống',

  //collection
  'collection.name': 'Bộ sưu tập',

  //category
  'category.name': 'Tên nhóm',
  'category.code': 'Mã nhóm',
  'category.itemQuantity': 'Số vật phẩm có trong nhóm',
  'category.action': 'Hành động',
  'category.router.name': 'Nhóm vật phẩm',
  'category.title': 'Quản lý nhóm vật phẩm',
  'category.update': 'Cập nhật nhóm vật phẩm',
  'category.information': 'Thông tin nhóm vật phẩm',
  'category.create': 'Tạo nhóm vật phẩm',
  'category.title.delete': 'Xóa nhóm vật phẩm',
  'category.content.delete': 'Bạn có chắc chắn muốn xóa nhóm vật phẩm này.',
  //users
  // 'users.name': 'Người dùng',

  //rankTimeSetting
  'rankTimeSetting.name': 'Thời gian chốt bảng xếp hạng',
  'rankTimeSetting.title': 'Thiết lập thời gian chốt bảng xếp hạng',
  'rankTimeSetting.time': 'Thời gian chốt thưởng',
  'rankTimeSetting.dateTime': 'Thời gian vận hành chương trình',
  'rankTimeSetting.placeholder.dayOfWeek': 'Chọn thứ trong tuần',
  'date.0': 'Chủ nhật',
  'date.1': 'Thứ 2',
  'date.2': 'Thứ 3',
  'date.3': 'Thứ 4',
  'date.4': 'Thứ 5',
  'date.5': 'Thứ 6',
  'date.6': 'Thứ 7',

  //errors
  'errors.name': 'Báo lỗi',
  'errors.title': 'Quản lý lỗi khách hàng báo',
  'errors.errorType.code': 'Loại lỗi',
  'errors.content': 'Nội dung lỗi',
  'errors.createdAt': 'Thời hạn báo lỗi',
  'errors.status': 'Trạng thái xử lý',
  'errors.status.param': '{status,select, 1 {Đã xử lý} 2 {Chưa xử lý} other {Không xác định}}',
  'errors.Processed': 'Đã xử lý',
  'errors.NoProcess': 'Chưa xử lý',
  'errors.check': 'Xử lý',
  'errors.title.warning': 'Không thế xử lý lỗi',
  'errors.content.warning': 'Bạn không thể xử lý lỗi trạng thái đã xử lý',
  'errors.title.delete': 'Xử lý lỗi',
  'errors.content.delete': 'Bạn có chắc chắn muốn xử lý lỗi này.',
  'errors.information': 'Thông tin lỗi',
  'errors.device.name': 'Tên thiết bị',
  'errors.device': 'Thiết bị',
  'errors.contact': 'Thông tin liên lạc',
};
